import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

// export default function FaultForthPart(props) {
const FaultForthPart = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [ECUData, setECUData] = useState({});
  const [TempDataCrit, setTempDataCrit] = useState([]);
  const [dataMainCrit, setDataMainCrit] = useState([]);
  const [toCalculateFaultCrit, setToCalculateFaultCrit] = useState(0);
  const [single_nameCrit, setsingle_nameCrit] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({});
  const [critcal_duration, setCritcal_duration] = useState([]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/faultanalysis_bus",
        body: { filterdata: gloablfilter },
      },
      ecuFaultResponse
    );
  }, [gloablfilter]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "sp" },
      },
      responceBarData
    );
  }, [ECUData]);

  const ecuFaultResponse = (data) => {
    const ecuDict = {};
    data.forEach((item) => {
      const ecu = item.key.ECU;
      const vehicleCount = item.vehicle_count.value;
      ecuDict[ecu] = vehicleCount;
    });
    setECUData(ecuDict);
  };

  const responceBarData = (data) => {
    if (data.defaultNav === "sp") {
      // setTempDataCrit([]);
      // setDataMainCrit([]);
      deno(data);
    }
  };

  const deno = async (data) => {
    if (data.defaultNav !== null && data.defaultNav === "sp") {
      //   if (ECUData.hasOwnProperty(defaultNav)) {
      await setTempDataCrit(data.result);
      await setToCalculateFaultCrit(ECUData["BMS"]);
      //   }
    }
  };

  useEffect(() => {
    if (toCalculateFaultCrit !== 0) {
      const data = TempDataCrit;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultCrit;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setCritcal_duration(maleAdd);
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainCrit(dataArray);
    }
  }, [toCalculateFaultCrit]);

  const chunks3 = chunkArray(dataMainCrit, 21);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      chunks3,
      ECUData,
      TempDataCrit,
      dataMainCrit,
      single_nameCrit,
      LineContainerBodyBD,
      toCalculateFaultCrit,
      critcal_duration,
    }),
  }));

  return (
    <div className="faultfirstpart">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-2">
        <div className="col-md-8">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Faults Observed in Field :{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div className="row mt-3 ">
        <div className="col-md-1"></div>
        <div className="col-md-8">
          <div className="row" style={{ textAlign: "right" }} id={"crit_title"}>
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                Critical
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainCrit.length > 0 ? (
                chunks3.map((chunk, chunkIndex) => (
                  <div
                    key={chunkIndex}
                    className={`pdf-page ${
                      chunkIndex === 0 ? "" : "pdf-page-extra-padding"
                    }`}
                  >
                    <COmpBiDirTest
                      dataMain={chunk}
                      // id={"Crit"}
                      id={`Crit-${chunkIndex}`}
                      gloablfilter={gloablfilter}
                      signal_name={single_nameCrit}
                    />
                    <div
                      className="row bottomcontent pl-4"
                      style={{ paddingTop: "155px" }}
                    >
                      <div className="col-md-3">
                        <img
                          src="../../../assets/img_Bus/Pdf_Page/footer.png"
                          alt=""
                          style={{ height: "70px", width: "200px" }}
                        />
                      </div>
                      <div className="col-md-1"></div>
                      <div className="col-md-4">
                        <p
                          style={{
                            fontSize: "11px",
                            paddingTop: "60px",
                            paddingLeft: "10px",
                          }}
                        >
                          Copyright, Confidential, Tata Motors Limited
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
        {/* <div></div> */}
        <div>
          {/* <div>Time Duration : {critcal_duration?.toFixed(0)}</div>
          <div>Vehicle Count : {toCalculateFaultCrit}</div> */}
        </div>
      </div>

      {/* <div className="row bottomcontent pl-4" style={{ paddingTop: "455px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div> */}
    </div>
  );
});

export default FaultForthPart;
